var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradiesNb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.43,
    height: 119.22,
    viewBox: "0 0 127.43 119.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f56329;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2-2",
    "data-name": "Layer 1-2-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.64,31.88,64.44,1.25a5.31,5.31,0,0,0-6.85,0L2.43,47.92A6.88,6.88,0,0,0,0,53.16v62a4.06,4.06,0,0,0,4.06,4.06H123.37a4.06,4.06,0,0,0,4.06-4.06V54a4.06,4.06,0,0,0-4.06-4H106.82a3.75,3.75,0,0,1-3.75-3.75h0V37.12A6.88,6.88,0,0,0,100.64,31.88Z",
    transform: "translate(0 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradiesNb);
export default __webpack_public_path__ + "static/media/tradies_nb.e54cfbf0aea55441638022bb72be5977.svg";
export { ForwardRef as ReactComponent };